import fetchFactory from '../../../../utils/fetchFactory'
import { configEnum } from '../../../../enum/fetchFactoryEnum'

export const updateRecoveryEmail = (email: string) => fetchFactory('/api/update/recover/email',
	{
		method: configEnum.post,
		body: JSON.stringify({ email })
	}
)
